export const SKU_LIST_JH030: string[] = [
"JH030-AiBl-XS",
"JH030-AiBl-S",
"JH030-AiBl-M",
"JH030-AiBl-L",
"JH030-AiBl-XL",
"JH030-AiBl-2XL",
"JH030-ArWh-XS",
"JH030-ArWh-S",
"JH030-ArWh-M",
"JH030-ArWh-L",
"JH030-ArWh-XL",
"JH030-ArWh-2XL",
"JH030-ArWh-3XL",
"JH030-ArWh-4XL",
"JH030-ArWh-5XL",
"JH030-As-XS",
"JH030-As-S",
"JH030-As-M",
"JH030-As-L",
"JH030-As-XL",
"JH030-As-2XL",
"JH030-BaPi-XS",
"JH030-BaPi-S",
"JH030-BaPi-M",
"JH030-BaPi-L",
"JH030-BaPi-XL",
"JH030-BaPi-2XL",
"JH030-BaPi-3XL",
"JH030-BaPi-4XL",
"JH030-BaPi-5XL",
"JH030-BlSm-XS",
"JH030-BlSm-S",
"JH030-BlSm-M",
"JH030-BlSm-L",
"JH030-BlSm-XL",
"JH030-BlSm-2XL",
"JH030-BoGr-XS",
"JH030-BoGr-S",
"JH030-BoGr-M",
"JH030-BoGr-L",
"JH030-BoGr-XL",
"JH030-BoGr-2XL",
"JH030-Bu-XS",
"JH030-Bu-S",
"JH030-Bu-M",
"JH030-Bu-L",
"JH030-Bu-XL",
"JH030-Bu-2XL",
"JH030-Bu-3XL",
"JH030-Bu-4XL",
"JH030-Bu-5XL",
"JH030-BuOr-XS",
"JH030-BuOr-S",
"JH030-BuOr-M",
"JH030-BuOr-L",
"JH030-BuOr-XL",
"JH030-BuOr-2XL",
"JH030-CaPi-XS",
"JH030-CaPi-S",
"JH030-CaPi-M",
"JH030-CaPi-L",
"JH030-CaPi-XL",
"JH030-CaPi-2XL",
"JH030-Ch-XS",
"JH030-Ch-S",
"JH030-Ch-M",
"JH030-Ch-L",
"JH030-Ch-XL",
"JH030-Ch-2XL",
"JH030-Ch-3XL",
"JH030-Ch-4XL",
"JH030-Ch-5XL",
"JH030-CoBl-XS",
"JH030-CoBl-S",
"JH030-CoBl-M",
"JH030-CoBl-L",
"JH030-CoBl-XL",
"JH030-CoBl-2XL",
"JH030-Cr-XS",
"JH030-Cr-S",
"JH030-Cr-M",
"JH030-Cr-L",
"JH030-Cr-XL",
"JH030-Cr-2XL",
"JH030-DeSa-XS",
"JH030-DeSa-S",
"JH030-DeSa-M",
"JH030-DeSa-L",
"JH030-DeSa-XL",
"JH030-DeSa-2XL",
"JH030-DuPi-XS",
"JH030-DuPi-S",
"JH030-DuPi-M",
"JH030-DuPi-L",
"JH030-DuPi-XL",
"JH030-DuPi-2XL",
"JH030-FiRe-XS",
"JH030-FiRe-S",
"JH030-FiRe-M",
"JH030-FiRe-L",
"JH030-FiRe-XL",
"JH030-FiRe-2XL",
"JH030-FiRe-3XL",
"JH030-FiRe-4XL",
"JH030-FiRe-5XL",
"JH030-FoGr-XS",
"JH030-FoGr-S",
"JH030-FoGr-M",
"JH030-FoGr-L",
"JH030-FoGr-XL",
"JH030-FoGr-2XL",
"JH030-Go-XS",
"JH030-Go-S",
"JH030-Go-M",
"JH030-Go-L",
"JH030-Go-XL",
"JH030-Go-2XL",
"JH030-HaBl-XS",
"JH030-HaBl-S",
"JH030-HaBl-M",
"JH030-HaBl-L",
"JH030-HaBl-XL",
"JH030-HaBl-2XL",
"JH030-HeGy-XS",
"JH030-HeGy-S",
"JH030-HeGy-M",
"JH030-HeGy-L",
"JH030-HeGy-XL",
"JH030-HeGy-2XL",
"JH030-HeGy-3XL",
"JH030-HeGy-4XL",
"JH030-HeGy-5XL",
"JH030-HoCh-XS",
"JH030-HoCh-S",
"JH030-HoCh-M",
"JH030-HoCh-L",
"JH030-HoCh-XL",
"JH030-HoCh-2XL",
"JH030-HoPi-XS",
"JH030-HoPi-S",
"JH030-HoPi-M",
"JH030-HoPi-L",
"JH030-HoPi-XL",
"JH030-HoPi-2XL",
"JH030-HoPi-3XL",
"JH030-IcBl-XS",
"JH030-IcBl-S",
"JH030-IcBl-M",
"JH030-IcBl-L",
"JH030-IcBl-XL",
"JH030-IcBl-2XL",
"JH030-Ja-XS",
"JH030-Ja-S",
"JH030-Ja-M",
"JH030-Ja-L",
"JH030-Ja-XL",
"JH030-Ja-2XL",
"JH030-JeBl-XS",
"JH030-JeBl-S",
"JH030-JeBl-M",
"JH030-JeBl-L",
"JH030-JeBl-XL",
"JH030-JeBl-2XL",
"JH030-JeBl-3XL",
"JH030-JeBl-4XL",
"JH030-JeBl-5XL",
"JH030-KeGr-XS",
"JH030-KeGr-S",
"JH030-KeGr-M",
"JH030-KeGr-L",
"JH030-KeGr-XL",
"JH030-KeGr-2XL",
"JH030-Kh-XS",
"JH030-Kh-S",
"JH030-Kh-M",
"JH030-Kh-L",
"JH030-Kh-XL",
"JH030-Kh-2XL",
"JH030-La-XS",
"JH030-La-S",
"JH030-La-M",
"JH030-La-L",
"JH030-La-XL",
"JH030-La-2XL",
"JH030-LiGr-XS",
"JH030-LiGr-S",
"JH030-LiGr-M",
"JH030-LiGr-L",
"JH030-LiGr-XL",
"JH030-LiGr-2XL",
"JH030-MoBr-XS",
"JH030-MoBr-S",
"JH030-MoBr-M",
"JH030-MoBr-L",
"JH030-MoBr-XL",
"JH030-MoBr-2XL",
"JH030-MoGy-XS",
"JH030-MoGy-S",
"JH030-MoGy-M",
"JH030-MoGy-L",
"JH030-MoGy-XL",
"JH030-MoGy-2XL",
"JH030-Mu-XS",
"JH030-Mu-S",
"JH030-Mu-M",
"JH030-Mu-L",
"JH030-Mu-XL",
"JH030-Mu-2XL",
"JH030-NeFrNa-XS",
"JH030-NeFrNa-S",
"JH030-NeFrNa-M",
"JH030-NeFrNa-L",
"JH030-NeFrNa-XL",
"JH030-NeFrNa-2XL",
"JH030-NeFrNa-3XL",
"JH030-NeFrNa-4XL",
"JH030-NeFrNa-5XL",
"JH030-Nu-XS",
"JH030-Nu-S",
"JH030-Nu-M",
"JH030-Nu-L",
"JH030-Nu-XL",
"JH030-Nu-2XL",
"JH030-OlGr-XS",
"JH030-OlGr-S",
"JH030-OlGr-M",
"JH030-OlGr-L",
"JH030-OlGr-XL",
"JH030-OlGr-2XL",
"JH030-OrCr-XS",
"JH030-OrCr-S",
"JH030-OrCr-M",
"JH030-OrCr-L",
"JH030-OrCr-XL",
"JH030-OrCr-2XL",
"JH030-OxNa-XS",
"JH030-OxNa-S",
"JH030-OxNa-M",
"JH030-OxNa-L",
"JH030-OxNa-XL",
"JH030-OxNa-2XL",
"JH030-Pe-XS",
"JH030-Pe-S",
"JH030-Pe-M",
"JH030-Pe-L",
"JH030-Pe-XL",
"JH030-Pe-2XL",
"JH030-PiGr-XS",
"JH030-PiGr-S",
"JH030-PiGr-M",
"JH030-PiGr-L",
"JH030-PiGr-XL",
"JH030-PiGr-2XL",
"JH030-Pl-XS",
"JH030-Pl-S",
"JH030-Pl-M",
"JH030-Pl-L",
"JH030-Pl-XL",
"JH030-Pl-2XL",
"JH030-Pu-XS",
"JH030-Pu-S",
"JH030-Pu-M",
"JH030-Pu-L",
"JH030-Pu-XL",
"JH030-Pu-2XL",
"JH030-Pu-3XL",
"JH030-RaGr-XS",
"JH030-RaGr-S",
"JH030-RaGr-M",
"JH030-RaGr-L",
"JH030-RaGr-XL",
"JH030-RaGr-2XL",
"JH030-ReHoCh-XS",
"JH030-ReHoCh-S",
"JH030-ReHoCh-M",
"JH030-ReHoCh-L",
"JH030-ReHoCh-XL",
"JH030-ReHoCh-2XL",
"JH030-RoBl-XS",
"JH030-RoBl-S",
"JH030-RoBl-M",
"JH030-RoBl-L",
"JH030-RoBl-XL",
"JH030-RoBl-2XL",
"JH030-RoBl-3XL",
"JH030-RoBl-4XL",
"JH030-RoBl-5XL",
"JH030-SaBl-XS",
"JH030-SaBl-S",
"JH030-SaBl-M",
"JH030-SaBl-L",
"JH030-SaBl-XL",
"JH030-SaBl-2XL",
"JH030-SaBl-3XL",
"JH030-SkBl-XS",
"JH030-SkBl-S",
"JH030-SkBl-M",
"JH030-SkBl-L",
"JH030-SkBl-XL",
"JH030-SkBl-2XL",
"JH030-SteGy-XS",
"JH030-SteGy-S",
"JH030-SteGy-M",
"JH030-SteGy-L",
"JH030-SteGy-XL",
"JH030-SteGy-2XL",
"JH030-StoGy-XS",
"JH030-StoGy-S",
"JH030-StoGy-M",
"JH030-StoGy-L",
"JH030-StoGy-XL",
"JH030-StoGy-2XL",
"JH030-SuYe-XS",
"JH030-SuYe-S",
"JH030-SuYe-M",
"JH030-SuYe-L",
"JH030-SuYe-XL",
"JH030-SuYe-2XL",
"JH030-VaMi-XS",
"JH030-VaMi-S",
"JH030-VaMi-M",
"JH030-VaMi-L",
"JH030-VaMi-XL",
"JH030-VaMi-2XL",
"JH030-TuSu-XS",
"JH030-TuSu-S",
"JH030-TuSu-M",
"JH030-TuSu-L",
"JH030-TuSu-XL",
"JH030-TuSu-2XL",
"JH030-DeeBl-XS",
"JH030-DeeBl-S",
"JH030-DeeBl-M",
"JH030-DeeBl-L",
"JH030-DeeBl-XL",
"JH030-DeeBl-2XL",
"JH030-DeeBl-3XL",
"JH030-DeeBl-4XL",
"JH030-DeeBl-5XL",
"JH030-DeGr-XS",
"JH030-DeGr-S",
"JH030-DeGr-M",
"JH030-DeGr-L",
"JH030-DeGr-XL",
"JH030-DeGr-2XL",
"JH030-ShGr-XS",
"JH030-ShGr-S",
"JH030-ShGr-M",
"JH030-ShGr-L",
"JH030-ShGr-XL",
"JH030-ShGr-2XL",
"JH030-CaLa-XS",
"JH030-CaLa-S",
"JH030-CaLa-M",
"JH030-CaLa-L",
"JH030-CaLa-XL",
"JH030-CaLa-2XL",
"JH030-DuRo-XS",
"JH030-DuRo-S",
"JH030-DuRo-M",
"JH030-DuRo-L",
"JH030-DuRo-XL",
"JH030-DuRo-2XL",
"JH030-GiBi-XS",
"JH030-GiBi-S",
"JH030-GiBi-M",
"JH030-GiBi-L",
"JH030-GiBi-XL",
"JH030-GiBi-2XL",
"JH030-EaGr-XS",
"JH030-EaGr-S",
"JH030-EaGr-M",
"JH030-EaGr-L",
"JH030-EaGr-XL",
"JH030-EaGr-2XL",
"JH030-PuPi-XS",
"JH030-PuPi-S",
"JH030-PuPi-M",
"JH030-PuPi-L",
"JH030-PuPi-XL",
"JH030-PuPi-2XL",
"JH030-DiLa-XS",
"JH030-DiLa-S",
"JH030-DiLa-M",
"JH030-DiLa-L",
"JH030-DiLa-XL",
"JH030-DiLa-2XL",
"JH030-ChFuBr-XS",
"JH030-ChFuBr-S",
"JH030-ChFuBr-M",
"JH030-ChFuBr-L",
"JH030-ChFuBr-XL",
"JH030-ChFuBr-2XL",
"JH030-DuLi-XS",
"JH030-DuLi-S",
"JH030-DuLi-M",
"JH030-DuLi-L",
"JH030-DuLi-XL",
"JH030-DuLi-2XL",
"JH030-FeFu-XS",
"JH030-FeFu-S",
"JH030-FeFu-M",
"JH030-FeFu-L",
"JH030-FeFu-XL",
"JH030-FeFu-2XL",
"JH030-GrHe-XS",
"JH030-GrHe-S",
"JH030-GrHe-M",
"JH030-GrHe-L",
"JH030-GrHe-XL",
"JH030-GrHe-2XL",
"JH030-NaSt-XS",
"JH030-NaSt-S",
"JH030-NaSt-M",
"JH030-NaSt-L",
"JH030-NaSt-XL",
"JH030-NaSt-2XL",
"JH030-LaBl-XS",
"JH030-LaBl-S",
"JH030-LaBl-M",
"JH030-LaBl-L",
"JH030-LaBl-XL",
"JH030-LaBl-2XL",
"JH030-BrRo-XS",
"JH030-BrRo-S",
"JH030-BrRo-M",
"JH030-BrRo-L",
"JH030-BrRo-XL",
"JH030-BrRo-2XL",
"JH030-Se-XS",
"JH030-Se-S",
"JH030-Se-M",
"JH030-Se-L",
"JH030-Se-XL",
"JH030-Se-2XL"
]